var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.792893 11.2929C0.402369 11.6834 0.402369 12.3166 0.792892 12.7071L7.15685 19.0711C7.54738 19.4616 8.18054 19.4616 8.57107 19.0711C8.96159 18.6805 8.96159 18.0474 8.57107 17.6569L2.91421 12L8.57107 6.34314C8.96159 5.95262 8.96159 5.31945 8.57107 4.92893C8.18054 4.53841 7.54738 4.53841 7.15686 4.92893L0.792893 11.2929ZM29.5 11L1.5 11L1.5 13L29.5 13L29.5 11Z",
    fill: "#FFFFF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.2d08c356b07032c9579af8320a779189.svg";
export { ForwardRef as ReactComponent };